import { ClientError } from 'graphql-request'

export const parseError = (error: unknown, defaultMessage?: string) => {
  // Handle GraphQL ClientError - extract clean message from response
  if (error instanceof ClientError) {
    const graphqlError = error.response.errors?.[0]
    if (graphqlError?.message) {
      return graphqlError.message
    }
  }

  // Handle standard Error objects
  if (error instanceof Error) {
    return error.message
  }

  // Handle string errors
  if (typeof error === 'string') {
    return error
  }

  // Fallback to default message
  return defaultMessage ?? 'An error occured'
}
